import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux';
import useStateRef from 'react-usestateref';
import { updateProfileDetailsAction } from '../../middleware/updateProfileDetailsAction';
import { miniCartItemCountAction } from '../../middleware/miniCartItemCountAction';
import { useHistory } from 'react-router';

const SessionTimeout = (props) => {

    const [sessionTimeOut, setSessionTimeOut, sessionTimeOutRef] = useStateRef(props && props.timeOut ? props.timeOut : 30 * 60 * 1000)
    const [url, setUrl] = useState();
    const [count, setCount,countRef] = useStateRef(0);
    const dispatch = useDispatch();
    const history = useHistory();
    function timeOut() {
        setTimeout(handleAlert, sessionTimeOutRef.current);
    }




    function handleAlert() {
        setCount(count+1)
        if(countRef.current == 1){
        document.getElementById("sessionWarningModal").click();
        }
       
        
    }


    const handleLogOut = () => {

        fetch(`${window.location.protocol}//${window.location.hostname}/api/rest/cb/profile/logout`, {
            method: 'GET'
        }).then(res => res.json())
            .then(res => {
                if (res.result === "success") {
                    // updating cart count
                    dispatch(updateProfileDetailsAction(true,"logout"))
                    var Url = `${window.location.protocol}//${window.location.hostname}/api/rest/cb/checkout/mini-cart-count`
                    dispatch(miniCartItemCountAction(Url))
                    localStorage.clear();
                    parent.location.href = "/account/login?sessionExpired=true";

                } else {
                    const error = res._ERROR_MESSAGE_;
                }
            })
    };

    useEffect(() => {
        setUrl(window.location.hostname)
        setSessionTimeOut(props.timeOut);
        timeOut();


    }, [props.timeOut])

    function handleResetSession() {
        document.getElementById("closeButton").click();
        setCount(0)
        timeOut();


    }



    return (
        <>
            <p id="sessionWarningModal" className="m-0" data-bs-toggle="modal" data-bs-target="#sessionWarning" data-bs-dismiss="modal" title=""></p>
            <div class="modal fade c-modal show" id="sessionWarning" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-modal="true" role="dialog">
                <div class="modal-dialog modal-dialog-centered modal-fullscreen-sm-down">
                    <div class="modal-content">
                        <div class="modal-body">
                            <div class="">
                                <div className="d-flex mb-2">
                                    <i class="bi bi-globe mx-2 sessionLogo"></i>
                                    <p class="sessionDomainName">
                                        {url}
                                    </p>
                                </div>    


                                <div class="d-flex mb-4">
                                    <div class=" text-black" dangerouslySetInnerHTML={{ __html: "Your session is going to expire,would you like to continue working?</br>Click 'Ok' to continue working or 'Cancel' to logout" }}></div>
                                </div>
                                <div style={{ "justify-content": "end", "display": "flex" }}>
                                    <button type="button" class="btn btn-primary d-none" data-bs-dismiss="modal" id="closeButton"></button>
                                    <button type="button" class="btn btn-light mx-2" onClick={() => handleResetSession()}>OK</button>
                                    <button type="button"  class="btn btn-primary" onClick={() => handleLogOut()}>Cancel</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}

export default SessionTimeout